import { observer } from 'mobx-react';
import { inject } from '../../../utils';
import * as React from 'react';
import { Component } from 'react';
import { withTheme } from 'styled-components';
import DownloadControls from '../DownloadControls';
import { computed } from 'mobx';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import {
    DownloadControlActions,
    PreviewActionOptions,
} from '../../../models/configuration/explorer/DownloadControls';
import { DocumentsGridActionsProps } from './Models';
import DownloadControlsWrapper from './StyledComponents/DownloadControlsWrapper';

@inject('dataStore', 'translationStore', 'entityStore')
@observer
class DocumentsGridActions extends Component<DocumentsGridActionsProps> {
    @computed
    get documentDisplayName(): string {
        const { dataStore, document, entityStore } = this.props;
        const { getDocumentDisplayName } = dataStore;

        return getDocumentDisplayName(document, entityStore?.value);
    }

    @computed
    get downloadControlActions(): DownloadControlActions {
        const { actions, dataStore } = this.props;
        return dataStore?.config.getDownloadControlActionsOrDefault({
            disableExtendedInfo: true,
            countOptions: {
                hide: true,
            },
            ...actions,
            _documentDisplayName: this.documentDisplayName,
        });
    }

    @computed
    get metricContext(): string {
        const { documentType, document, columnId } = this.props;
        // For the column Documents Grid, the document type will be false, as we are not grouping the documents
        // We are generating the id within the configStore to ensure uniqueness
        return `documentsGrid-${camelCase(
            documentType || columnId
        )}-${camelCase(document.title)}-${document.clientCode}`;
    }

    render() {
        const {
            theme,
            dataStore,
            translationStore,
            entityStore,
            document,
            documentType,
            toggleDownload,
            documentSelected,
            showCheckbox,
            columnId,
        } = this.props;
        const {
            downloadDocuments,
            getDocumentLink,
            previewDocuments,
            getFileName,
        } = dataStore;

        return (
            <DownloadControlsWrapper
                {...theme.DownloadControlsWrapper}
                role="group"
                aria-label={translationStore.translate('Download Controls')}
            >
                <DownloadControls
                    // ------ download
                    onClick={event => {
                        event.stopPropagation();
                        downloadDocuments([document], entityStore?.value);
                    }}
                    // ------ checkbox
                    showCheckbox={showCheckbox}
                    selected={documentSelected(document.clientCode)}
                    onChange={() =>
                        toggleDownload(
                            document,
                            entityStore?.value?.clientCode,
                            columnId
                        )
                    }
                    // ------ preview
                    onPreviewClick={(
                        event,
                        elementOptions: PreviewActionOptions
                    ) => {
                        event.stopPropagation();
                        previewDocuments(
                            [document],
                            entityStore?.value,
                            elementOptions
                        );
                    }}
                    // ------ actions
                    actions={this.downloadControlActions}
                    // ------ count
                    count={1} // Hardcoded since there is 1 document per row in this context
                    showCount={false}
                    // ------ document
                    document={document}
                    documentType={documentType}
                    documentDisplayName={this.documentDisplayName}
                    href={getDocumentLink([document], entityStore?.value)}
                    fileName={getFileName([document], entityStore?.value)}
                    // ------ common
                    metricContext={this.metricContext}
                    componentThemeKey="Documents"
                />
            </DownloadControlsWrapper>
        );
    }
}

export default withTheme(DocumentsGridActions) as any;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGridActions/index.tsx